/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventaistartworkingsubtitle4Inputs */

const en_eventaistartworkingsubtitle4 = /** @type {(inputs: Eventaistartworkingsubtitle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading the link, pictures and text. You can check everything afterwards.`)
};

const de_eventaistartworkingsubtitle4 = /** @type {(inputs: Eventaistartworkingsubtitle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link, Bilder und Text werden gelesen. Danach kannst du alles prüfen.`)
};

/**
* | output |
* | --- |
* | "Reading the link, pictures and text. You can check everything afterwards." |
*
* @param {Eventaistartworkingsubtitle4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventaistartworkingsubtitle4 = /** @type {((inputs?: Eventaistartworkingsubtitle4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventaistartworkingsubtitle4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventaistartworkingsubtitle4(inputs)
	return de_eventaistartworkingsubtitle4(inputs)
});
export { eventaistartworkingsubtitle4 as "eventAiStartWorkingSubtitle" }